import {useMemo} from "react";
import DBModal from "../../../../component/global/DBModal";
import logo from './../../../../asset/image/logo_1.svg'
import DBButton from "../../../../component/global/DBButton";
import BackButton from "../../../../component/global/BackButton";
import {useTranslation} from "react-i18next";
import {numberWithCommas} from "../../../../utils/methods";

function PackagesPaymentStatusModal(props) {
  const {status, onHide, show, onClick, data} = props
  const {t} = useTranslation();

  const statusClassName = status ? 'success' : 'failed'
  const statusTitle = status ? t('Organizational.Profile.Packages.Payment.Status.Success') : t('Organizational.Profile.Packages.Payment.Status.Failed')
  const btnTitle = status ? t('Organizational.Profile.Packages.Payment.Status.Print.Label') : t('Organizational.Profile.Packages.Payment.Status.TryAgain.Label')

  const month = useMemo(() => {
    return (data?.duration_as_days / 30) || 0
  }, [data?.duration_as_days])

  const finalDiscount = useMemo(() => {
    if (data?.price) {
      const discount = data?.discount?.value || 0
      const price = data?.price || 0
      const percent = discount / 100
      return price * percent
    }
    return 0
  }, [data?.discount?.value, data?.price])

  const totalAmount = useMemo(() => {
    if (data?.price) {
      const tax = data?.task_percent || 0
      const finalPrice = data?.price - finalDiscount
      return finalPrice + (finalPrice * (tax / 100))
    }
    return 0
  }, [data?.price, data?.task_percent, finalDiscount])

  return (
    <DBModal
      minWidth={300}
      show={show}
      onHide={onHide}
      className="packages-payment-status-modal"
    >
      <DBModal.Content>
        <div className='header-modal'>
          <div className='logo'>
            <img src={logo} alt='logo'/>
          </div>
          <BackButton onclickFunction={onHide}/>
        </div>
        <div className='content-modal'>
          <div className='status-modal'>
            <div className={`title ${statusClassName}`}>{statusTitle}</div>
            <div
              className='receipt'>{t('Organizational.Profile.Packages.Payment.Status.Receipt')}: <span>{data?.code}</span>
            </div>
          </div>
          <div className='detail-modal'>
            <div className="detail-box">
              <div className='title'>
                {t('Organizational.Profile.Packages.Payment.Status.Title')}
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Type')}: <span>{data?.package?.name}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Time')}: <span>{month} {t('Organizational.Profile.Packages.Payment.Time')}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Price')}: <span>{numberWithCommas(`${data?.price || 0}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Discount')}: <span>{numberWithCommas(`${finalDiscount}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
              </div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.AddedValue')}: <span>%{data?.task_percent}</span>
              </div>
              <div className='divider'></div>
              <div className='detail'>
                {t('Organizational.Profile.Packages.Payment.Status.Total')}: <span>{numberWithCommas(`${totalAmount}`)} {t('Organizational.Profile.Packages.Payment.Unit')}</span>
              </div>
            </div>
          </div>
          <div className='btn-modal'>
            <DBButton
              caption={t('Organizational.Profile.Packages.Payment.Status.BtnClose.Label')}
              className='btn-close'
              onClick={onHide}
            />
            <DBButton caption={btnTitle} className='print' onClick={onClick}/>
          </div>
        </div>
      </DBModal.Content>
    </DBModal>
  );
}

export default PackagesPaymentStatusModal;
